module.exports = __webpack_public_path__ + "static/img/nekker2.d34ce71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/nekker2.png
// module id = x6OL
// module chunks = 0